import React from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

function Navbar() {
  return (
    <nav className="navbar">
      <h1>CSV to UMS V: 1.1.1</h1>
      <div className="links">
        <Link to="/" className="active">Home</Link>
        <Link to="/upload" className="disabled">Upload</Link>
        <Link to="/data" className="disabled">Data View</Link>
        <Link to="/export" className="disabled">Export</Link>
      </div>
    </nav>
  );
}

export default Navbar;